export default "__VITE_ASSET__DK_CjoE7__"